import includes from 'lodash/includes';

import {
  INTERSTITIAL_ENABLED_LIST,
  CUSTOM_LANDING_ENABLED_LIST,
  getPartnerWelcomePageType,
  PartnerWelcomePageType,
} from '../../utils/partner';
import type { AppData } from '../../types/app_data';
import type { Step } from '../types/step';

export const PartnerStep: Step = {
  // Partner landing page
  id: 'welcome',
  pathname: '/welcome',
  excludeFromProgressCalculation: true,
  canShow: (appData: AppData) => {
    // hide for onboarding lite
    if (appData.isOnboardingLite) return false;

    // Note: showing interstitial to stash traffic is under ab test.
    if (appData.partner?.partner === 'stash') return !!appData.featureData?.stashInterstital;

    // For 'cbautogroup', we don't want to show custom landing if traffic is from widget.
    if (
      appData.partner?.partner === 'cbautogroup' &&
      (appData.partner?.data.utm_campaign === 'advantage_widget' ||
        appData.partner?.data.utm_campaign === 'union_widget')
    )
      return false;

    if (appData.hasPassedInterstitial) return false;

    // Only show custom landing page for facebook if it's from facebook instead of other places like index3.
    if (appData.partner?.partner === 'facebook' && appData.utmSourceFromSignupQuery !== 'facebook') {
      return false;
    }

    return (
      appData.featureData?.askPhoneNamePrefilled ||
      includes([...CUSTOM_LANDING_ENABLED_LIST, ...INTERSTITIAL_ENABLED_LIST], appData.partner?.partner)
    );
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => {
    // Only welcome landing page needs to confirm hasOwnData, other pages can go next directly
    if (getPartnerWelcomePageType(appData) !== PartnerWelcomePageType.WelcomeLanding) {
      return true;
    }

    // If we showed prefilled name page with phone number input,
    // check if name and phone is saved into 'appData'.
    if (appData.featureData?.askPhoneNamePrefilled) {
      /**
       * If AB test is on, we should check if name is prefilled.
       * We will show phone step later.
       */
      if (appData.featureData?.prefillQuotingVariation) {
        return !!appData.name && !!appData.phone;
      }
      return !!appData.name && !!appData.phone && !!appData.signupUserSuccess;
    }
    return true;
  },
};
